export default __webpack_public_path__ + "88cb798684bb4f456b1991a237ba4e2b.pdf";